import _ from "lodash";
import React, { Fragment, useRef } from "react";
import classes from "./PostFeed.scss";
import PostCard from "AppComponents/Cards/PostCard";
import update from "immutability-helper";
import ConditionalWrapper from "Utils/ConditionalWrapper";
import { KeyboardNavigableList } from "UIComponents/KeyboardNavigableList";

const PostFeed = ({
  items,
  isMultiSelect,
  selectedItems,
  updateSelectedItems,
  styles,
  disabledItems,
  cardWrapperElement,
  customHeaderElement,
  newPosts,
  customCardComponent,
  totalCount,
  testId,
}) => {
  const postFeedContainerRef = useRef(null);
  const checkIsSelected = ({ id }) => {
    let isSelected = false;
    if (isMultiSelect) {
      isSelected = _.includes(selectedItems, id);
    } else {
      isSelected = selectedItems == id;
    }
    return isSelected;
  };

  const selectPost = ({ id }) => {
    if (isMultiSelect) {
      const index = _.indexOf(selectedItems, id);
      let selectedItemsLocal = [];
      if (index < 0) {
        selectedItemsLocal = update(selectedItems, { $push: [id] });
      } else {
        selectedItemsLocal = update(selectedItems, { $splice: [[index, 1]] });
      }
      updateSelectedItems(selectedItemsLocal);
    } else {
      updateSelectedItems(selectedItems == id ? "" : id);
    }
  };

  const checkIsDisabled = ({ id }) => {
    return _.findIndex(disabledItems, item => item == id) > -1;
  };

  const renderPostFeed = () => {
    return (
      <Fragment>
        {customHeaderElement &&
          React.cloneElement(customHeaderElement, {
            count: _.size(items),
            totalCount,
          })}
        <KeyboardNavigableList listContainerRef={postFeedContainerRef}>
          <div
            ref={postFeedContainerRef}
            className={classes.postFeedCon}
            style={styles.itemFeedContainer}
          >
            {_.map(items, item => {
              const isSelected = checkIsSelected({ id: item.id });
              const isDisabled = checkIsDisabled({ id: item.id });

              const isNewPost = _.includes(newPosts, item.id);

              return customCardComponent ? (
                React.cloneElement(customCardComponent, {
                  id: item.id,
                  createdBy: item.createdBy,
                  attachments: item.attachments,
                  onClickSelection: selectPost,
                  isSelected: isSelected,
                  isDisabled: isDisabled,
                  items: _.get(item, "items", []),
                  data: item,
                  testId: testId ? `${testId}-item` : undefined,
                })
              ) : (
                <div
                  className={classes.postFeedItem}
                  key={item.id}
                  data-test-id={testId ? `${testId}-item` : undefined}
                >
                  <ConditionalWrapper
                    type="wrapperAsElement"
                    wrapper={cardWrapperElement}
                    data={item}
                    isSelected={isSelected}
                    onCardClick={selectPost}
                    isNew={isNewPost}
                    condition={!!cardWrapperElement}
                  >
                    <PostCard
                      id={item.id}
                      key={item.id}
                      title={item.title}
                      createdBy={item.createdBy}
                      attachments={item.attachments}
                      onPostSelectionCardClick={selectPost}
                      isSelected={isSelected}
                      isDisabled={isDisabled}
                      styles={styles}
                      hideDefaultActions={!!cardWrapperElement}
                      items={_.get(item, "items", [])}
                    />
                  </ConditionalWrapper>
                </div>
              );
            })}
          </div>
        </KeyboardNavigableList>
      </Fragment>
    );
  };

  return <div className={classes.container}>{renderPostFeed()}</div>;
};

const comparisonFunction = (prevProps, nextProps) => {
  const propKeys = _.keys(nextProps);

  return _.reduce(
    propKeys,
    (result, prop) => {
      if (_.isEqual(prevProps[prop], nextProps[prop])) {
        return result;
      }
      return false;
    },
    true
  );
};

PostFeed.defaultProps = {
  newPosts: [],
};

export default React.memo(PostFeed, comparisonFunction);
